module.exports = __webpack_public_path__ + "media/images/mail-48464ab469ead179d7804232bb0b801f.svg";